import React, { useEffect, useState } from 'react';
import {
  LOGIN_VOUCHER_REDIRECT_KEY,
  LOGIN_VOUCHER_REDIRECT_VALUE,
} from '@/config';

import { ModalProvider } from '@/context/ModalProvider';

import { Section } from '@/components/global/Section';
import { Title } from '@/components/global/Title';
import { Description } from '@/components/global/Description';
import { Slider } from '@/components/Template/Template5/Slider';
import { CardInfo } from '@/components/Template/Template5/CardInfo';
import { CardLeft } from '@/components/Template/Template5/CardLeft';
import { Header } from '@/components/Template/Template5/Header';
import { Tabs } from '@/components/Template/Template5/Tabs';

import { TRecommendation } from '@/services/requests/Recommendation/types/template5';

import { scrollTo } from '@/helpers/ScrollTo';
import { getLayoutClass } from '@/helpers/HtmlHelper/getLayoutClass';

import useTabs from './useTabs';

type TProps = {
  data: TRecommendation[];
};

const TemplateVitrine5 = ({ data }: TProps) => {
  const { tabItems, onTabClick, getTabActive } = useTabs(data);
  const currentData = data.find(
    item => item.idLiferay === getTabActive(),
  ) as TRecommendation;

  const [tabChange, setTabChange] = useState(false);

  const {
    rec_title: { title, description },
    notes,
    info,
  } = currentData;
  const { layout } = data[0];

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const voucherModal = Number(params.get(LOGIN_VOUCHER_REDIRECT_KEY));

    if (voucherModal === LOGIN_VOUCHER_REDIRECT_VALUE) {
      scrollTo('recsys_templates_voucher-aereas');

      const event = new CustomEvent('smls-b2c-modals-open', {
        detail: {},
      });
      window.dispatchEvent(event);

      params.delete(LOGIN_VOUCHER_REDIRECT_KEY);
      const newUrl = `${window.location.pathname}${
        Array.from(params).length >= 1 ? `?${params.toString()}` : ''
      }`;
      window.history.replaceState(null, '', newUrl);
    }
  }, []);

  useEffect(() => {
    if (tabChange) {
      setTabChange(false);
    }
  }, [tabChange]);

  const handleTabClick = (tabId: string) => {
    setTabChange(true);
    onTabClick(tabId);
  };

  return (
    <ModalProvider theme="smiles">
      <Section
        className={`${getLayoutClass('5', layout)} ${info && info.theme}`}
        data={data}
      >
        <div className="vitrine-template5__container">
          <Tabs tabItems={tabItems} handleTabClick={handleTabClick} />
          {currentData.header && <Header data={currentData.header} />}
          <Title data={{ title }} template="5" />
          <Description data={{ description }} template="5" />
          <CardInfo data={currentData} />
          {!tabChange && <CardLeft data={currentData} />}
          <Slider data={data[0]} />
          <span className="vitrine-template5__moreinfo">
            {notes
              .split(/\*+/)
              .filter(item => item)
              .map(
                (note, index) =>
                  note && (
                    <React.Fragment key={note}>
                      {index > 0 && <br />}*{Array(index + 1).join('*')}
                      {note}
                    </React.Fragment>
                  ),
              )}
          </span>
        </div>
      </Section>
    </ModalProvider>
  );
};

export default TemplateVitrine5;
